// tslint:disable:no-any
// tslint:disable:jsx-no-string-ref

import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';
import Title from '../components/Title';
import PublicHeader from '../components/PublicHeader';
import TermsContent from '../components/TermsContent';

interface ITermsAndConditionsState {
  height: number;
  scrollTo: any;
}

class TermsAndConditions extends Component<{}, ITermsAndConditionsState> {
  constructor() {
    super({});
    this.state = {
      height: 600,
      scrollTo: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = 'WetNotes | Terms and Conditions';
  }

  componentWillMount() {
    this.setState({
      height: window.innerHeight - 525
    });
  }

  scrollTo(refName: any) {
    this.setState({
      scrollTo: refName
    });
  }

  render() {
    return (
      <div className="terms-and-conditions">
        <PublicHeader scrollTo={e => this.scrollTo(e)} />

        {this.state.scrollTo && (
          <Redirect
            to={{
              pathname: '/',
              state: {
                scrollTo: this.state.scrollTo
              }
            }}
          />
        )}

        <Title />

        <section style={{ minHeight: this.state.height }}>
          <div className="wrapper">
            <h1>Terms and Conditions</h1>
            <TermsContent />
          </div>
        </section>

        <Footer ref="footer" logged={false} />

        <CookieConsent />
      </div>
    );
  }
}

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/TermsAndConditions.tsx